import api from '.';
import { ElectricalListGroup } from '../pages/MasterData/ElectricalListGroup/electricalListGroupSlice';

interface ReturnTypeElectricalListGroup {
  data: ElectricalListGroup[];
}

export async function getElectricalListGroups(): Promise<ReturnTypeElectricalListGroup> {
  const { data } = await api.get('/electrical-list-groups');

  return data;
}
